<app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
  @if ({
    jobseekerEducation: jobseekerEducation$ | async,
    educationLevelList: educationLevelList$ | async,
    monthList: monthList$ | async,
    isInstitutionListAvailable: isInstitutionListAvailable$ | async,
    isProgramListAvailable: isProgramListAvailable$ | async,
    institutionSelectModeOn: institutionSelectModeOn$ | async,
    programSelectModOn: programSelectModOn$ | async,
    educationLevel: educationLevel$ | async,
    isProgramAvailable: isProgramAvailable$ | async,
    isSpecializationAvailable: isSpecializationAvailable$ | async,
    hasAttachment: hasAttachment$ | async,
    programList: programList$ | async,
    filteredProgramOptions: filteredProgramOptions$ | async,
    educationalInstitutionList: educationalInstitutionList$ | async,
    filteredInstitutionOptions: filteredInstitutionOptions$ | async,
    selectedFile: selectedFile$ | async,
    educationalInstitutionMap: educationalInstitutionMap$ | async,
    programMap: programMap$ | async,
    isFileUploading: isFileUploading$ | async,
    selectedFileText: selectedFileText$ | async,
    systemConfigs: systemConfigs$ | async,
    isFileSizeValid: isFileSizeValid$ | async,
    jobseekerId: jobseekerId$ | async,
    moderationLastChangeDate: moderationLastChangeDate$ | async
  }; as data) {
    <form [formGroup]="editForm" #ngForm="ngForm" [appConnectForm]="data.jobseekerEducation" class="education-edit">
      <div class="education-edit__header">
        <h2 class="education-edit__title">{{ title | translate }}</h2>
        <button type="button" class="education-edit__close" [mat-dialog-close]="true" [attr.aria-label]="'label.Close' | translate">
          <svg-icon src="/assets/icons/dialog-close.svg"></svg-icon>
        </button>
      </div>

      <div class="education-edit__body">
        <div class="fields">
          <div>
            <hrra-floating-field>
              <p-select
                inputId="education-level"
                formControlName="educationLevelId"
                [options]="data.educationLevelList"
                optionLabel="name"
                optionValue="value"
                [class.has-error]="editForm.controls['educationLevelId'].hasError('required') && (editForm.controls['educationLevelId'].touched || ngForm.submitted)"
                appDialogPanel
                (onChange)="onLevelChanage($event)">
              </p-select>
              <label for="education-level">{{ 'label.EducationLevel' | translate }} *</label>
            </hrra-floating-field>
            @if (editForm.controls['educationLevelId'].hasError('required') && (editForm.controls['educationLevelId'].touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div>
            @if (data.institutionSelectModeOn && data.isInstitutionListAvailable) {
              <hrra-floating-field [class.has-error]="editForm.hasError('institution') && (editForm.controls['educationalInstitutionId'].touched || ngForm.submitted)">
                <input
                  pInputText
                  id="education-institution"
                  type="text"
                  formControlName="educationalInstitutionId"
                  [matAutocomplete]="institutionAutocomplete"
                  (input)="onInstitutionSearchChange($event.target.value)">
                <label for="education-institution">{{ (institutionNameMap[data.educationLevel] ?? 'label.InstitutionName') | translate }} *</label>
              </hrra-floating-field>

              <mat-autocomplete
                #institutionAutocomplete="matAutocomplete"
                class="education-edit-autocomplete"
                (optionSelected)="onChangaeInstitution($event)"
                [displayWith]="displayInstitution.bind(this, data.educationalInstitutionList)">
                @for (institution of data.filteredInstitutionOptions; track institution.educationalInstitutionId) {
                  <mat-option [value]="institution.educationalInstitutionId">{{ institution.displayName }}</mat-option>
                }
              </mat-autocomplete>

              @if (editForm.hasError('institution') && (editForm.controls['educationalInstitutionId'].touched || ngForm.submitted)) {
                <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
              }
            }

            @if (!data.institutionSelectModeOn) {
              <hrra-floating-field [class.has-error]="editForm.hasError('institution') && (editForm.controls['institution'].touched || ngForm.submitted)">
                <input pInputText id="education-institution-name" maxlength="200" type="text" formControlName="institution" name="institution">
                <label for="education-institution-name">{{ (institutionNameMap[data.educationLevel] ?? 'label.InstitutionName') | translate }} *</label>
              </hrra-floating-field>
              @if (editForm.hasError('institution') && (editForm.controls['institution'].touched || ngForm.submitted)) {
                <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
              }
            }

            @if (data.isInstitutionListAvailable) {
              <button type="button" class="mode-switch" (click)="onInstitutionSelectMode()">
                {{ (data.institutionSelectModeOn ? institutionNameNotInListLabelMap[data.educationLevel] : 'label.SelectFromList') | translate }}
              </button>
            }
          </div>

          @if (data.isProgramAvailable) {
            <div>
              @if (data.programSelectModOn) {
                <hrra-floating-field [class.has-error]="editForm.hasError('program') && (editForm.controls['educationalProgramId'].touched || ngForm.submitted)">
                  <input
                    pInputText
                    id="education-program"
                    type="text"
                    formControlName="educationalProgramId"
                    [matAutocomplete]="programAutocomplete"
                    (input)="onProgramSearchChange($event.target.value)">
                  <label for="education-program">{{ 'label.EducationalProgram' | translate }} *</label>
                </hrra-floating-field>

                <mat-autocomplete
                  #programAutocomplete="matAutocomplete"
                  class="education-edit-autocomplete"
                  [displayWith]="displayProgram.bind(this, data.programList)">
                  @for (program of data.filteredProgramOptions; track program.educationalProgramId) {
                    <mat-option [value]="program.educationalProgramId">{{ program.displayName }}</mat-option>
                  }
                </mat-autocomplete>

                @if (editForm.hasError('program') && (editForm.controls['educationalProgramId'].touched || ngForm.submitted)) {
                  <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
                }
              } @else {
                <hrra-floating-field [class.has-error]="editForm.hasError('program') && (editForm.controls['educationalProgramName'].touched || ngForm.submitted)">
                  <input pInputText id="education-program-name" maxlength="200" type="text" formControlName="educationalProgramName" name="educationalProgramName">
                  <label for="education-program-name">{{ 'label.EducationalProgram' | translate }} *</label>
                </hrra-floating-field>
                @if (editForm.hasError('program') && (editForm.controls['educationalProgramName'].touched || ngForm.submitted)) {
                  <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
                }
              }

              @if (data.isProgramListAvailable) {
                <button type="button" class="mode-switch" (click)="onProgramSelectMode()">
                  {{ (data.programSelectModOn ? 'label.ProgramNotInList' : 'label.SelectFromList') | translate }}
                </button>
              }
            </div>
          }

          @if (data.isSpecializationAvailable) {
            <hrra-floating-field>
              <input pInputText id="education-specialization" maxlength="200" type="text" formControlName="specialization" name="specialization">
              <label for="education-specialization">{{ 'label.Specialization' | translate }}</label>
            </hrra-floating-field>
          }

          <div>
            <div class="dates">
              <div class="dates__group">
                <span class="dates__caption">{{ 'label.StartDate' | translate }}</span>
                <div class="dates__fields">
                  <hrra-floating-field>
                    <p-select inputId="education-date-from-month" formControlName="dateFromMonth" [options]="data.monthList" optionLabel="name" optionValue="value" [showClear]="true" appDialogPanel></p-select>
                    <label for="education-date-from-month">{{ 'label.MonthLabel' | translate }}</label>
                  </hrra-floating-field>

                  <hrra-floating-field class="dates__year" [class.has-error]="editForm.controls['dateFromYear'].invalid && (editForm.controls['dateFromYear'].touched || ngForm.submitted)">
                    <input pInputText id="education-date-from-year" maxlength="4" type="text" formControlName="dateFromYear" name="dateFromYear">
                    <label for="education-date-from-year">{{ 'label.YearLabel' | translate }} *</label>
                  </hrra-floating-field>
                </div>
              </div>

              <div class="dates__group">
                <span class="dates__caption">{{ 'label.EndDate' | translate }}</span>
                <div class="dates__fields">
                  <hrra-floating-field>
                    <p-select inputId="education-date-to-month" formControlName="dateToMonth" [options]="data.monthList" optionLabel="name" optionValue="value" [showClear]="true" appDialogPanel></p-select>
                    <label for="education-date-to-month">{{ 'label.MonthLabel' | translate }}</label>
                  </hrra-floating-field>

                  <hrra-floating-field class="dates__year" [class.has-error]="editForm.controls['dateToYear'].invalid && (editForm.controls['dateToYear'].touched || ngForm.submitted)">
                    <input pInputText id="education-date-to-year" maxlength="4" type="text" formControlName="dateToYear" name="dateToYear">
                    <label for="education-date-to-year">{{ 'label.YearLabel' | translate }} *</label>
                  </hrra-floating-field>
                </div>
              </div>
            </div>

            @if ((editForm.controls['dateFromYear'].hasError('required') && (editForm.controls['dateFromYear'].touched || ngForm.submitted))
              || (editForm.controls['dateToYear'].hasError('required') && (editForm.controls['dateToYear'].touched || ngForm.submitted))) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
            @if ((editForm.controls['dateFromYear'].hasError('pattern') && (editForm.controls['dateFromYear'].touched || ngForm.submitted))
              || (editForm.controls['dateToYear'].hasError('pattern') && (editForm.controls['dateToYear'].touched || ngForm.submitted))) {
              <mat-error class="validation-message">{{ 'message.IncorrectFormat' | translate }}</mat-error>
            }
            @if (editForm.hasError('year') && (editForm.controls['dateToYear'].touched || ngForm.submitted) && editForm.controls['dateToYear'].valid && editForm.controls['dateFromYear'].valid) {
              <mat-error class="validation-message">{{ 'message.StartDateMustNotComeAfterEndDate' | translate }}</mat-error>
            }
          </div>

          <hrra-floating-field class="description-field">
            <textarea
              pTextarea
              id="education-description"
              class="description"
              formControlName="description"
              name="description"
              [placeholder]="'label.DescriptionEgEducation' | translate">
            </textarea>
            <label for="education-description">{{ 'label.AdditionalInformation' | translate }}</label>
          </hrra-floating-field>

          <div class="attachment">
            @if (data.hasAttachment) {
              <button type="button" class="attachment-link" (click)="downloadAttachment(data.jobseekerEducation?.jobseekerEducationId, data.jobseekerId)">
                <svg-icon src="/assets/icons/profile-attachment.svg" class="attachment-link__icon"></svg-icon>
                {{ 'label.Attachment' | translate }}
              </button>
            }

            <hrra-file-upload
              [label]="(data.hasAttachment ? 'label.Change' : 'label.AttachDocument') | translate"
              [hint]="'label.EgDiploma' | translate"
              [fileName]="data.selectedFile?.filename != null ? data.selectedFileText : null"
              [uploading]="data.isFileUploading"
              [invalid]="data.isFileSizeValid === false"
              (fileSelected)="onFileSelect($event, data.systemConfigs.jobseeker.jobseekerAttachmentMaxSize, data.jobseekerId)">
            </hrra-file-upload>

            @if (data.isFileSizeValid === false) {
              <mat-error class="validation-message">{{ 'message.JobseekerFileSizeValidation' | translate }}</mat-error>
            }
          </div>
        </div>

        <div class="actions">
          <button
            type="submit"
            class="actions__button actions__button--save"
            (click)="
              onSave(
                data.jobseekerEducation?.jobseekerEducationId,
                data.educationalInstitutionMap,
                data.programMap,
                data.selectedFile,
                data.isFileSizeValid,
                data.jobseekerEducation?.objectId,
                data.moderationLastChangeDate,
                data.jobseekerId
              )
            ">
            {{ 'label.Save' | translate }}
          </button>
          <button type="button" class="actions__button actions__button--cancel" [mat-dialog-close]="true">{{ 'label.Cancel' | translate }}</button>
        </div>
      </div>
    </form>
  }
</app-spinner>
